import { useEffect, useState } from "react";
import "../Cursadas.css"
import "./Calificaciones.css"

import { getAllScoresByModule } from '../../../../Services/Scores.js';


export default function Calificaciones (props){

    const [courseScores, setCourseScores] = useState([]);
    const [moduleScores, setModuleScores] = useState([]);
    
    const loadModules = async () => {

        let rsp = await getAllScoresByModule(props.courseInfo.id);
            

        if(rsp?.Error === false){
            setCourseScores(rsp.Data.course_scores);
            setModuleScores(rsp.Data.modules_scores);
        }else{
            window.alert('No se pudieron cargar las calificaciones en este momento.');
        }
    }


    useEffect(() => {
        loadModules();
    }, []);


    
    return(
        <div className="frame">
            <div className='entregas-container'>
                <h1 className="entregas-course-title">{props.courseInfo.title}</h1>
                <h3 className="entregas-course-title">Calificaciones de curso</h3>
                {
                    courseScores.map((item, index) => {
                        return(
                            <div className='corese-calification-div' key={index}>
                                <h3 className="corese-calification-element">{item.created_at}</h3>
                                {
                                    item.id_score_types === 1 ?
                                    <h3 className="corese-calification-element">{item.conceptual}</h3>
                                    :
                                    <h3 className="corese-calification-element">{item.numeric}</h3>
                                }
                                {
                                    item.certification !== null ?
                                    <h3 className="corese-calification-element"><a className='green-btn' target='_blank' href={item.certification}>Ver Certificado</a></h3>
                                    :
                                    <h3 className="corese-calification-element">No existe certificado</h3>
                                }
                            </div>
                        );
                    })
                }
                <h3 className="entregas-course-title">Calificaciones de modulos</h3>
                {
                    moduleScores.map((item, index) => {
                        return(
                            <div className='corese-calification-div' key={index}>
                                <h3 className="corese-calification-element">{item.created_at}</h3>
                                <h3 className="corese-calification-element">{item.title}</h3>
                                {
                                    item.id_score_types === 1 ?
                                    <h3 className="corese-calification-element">{item.conceptual}</h3>
                                    :
                                    <h3 className="corese-calification-element">{item.numeric}</h3>
                                }
                            </div>
                        );
                    })
                }
            </div>
        </div>            
    );
}